import React, { useCallback, useEffect, useState } from 'react';
import 'keen-slider/keen-slider.min.css';
// components
import { useMobxStores } from '@stores/store';
import {
  has as _has,
  isEmpty as _isEmpty,
  toNumber as _toNumber,
} from 'lodash';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import TopBanner from '@organisms/media/common/TopBanner';
import MediaTab from '@organisms/media/mobile/MediaTab';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';

import MediaScrollData from '@organisms/media/mobile/MediaScrollData';
import { useWindowSize } from 'usehooks-ts';

const MediaList = () => {
  const { i18n } = useTranslation();
  const { settingStore, mediaStore } = useMobxStores();

  const navigate = useNavigate();
  const location = useLocation();
  const [activeCtg, setActiveCtg] = useState(0);
  const [pageNum, setPageNum] = useState(0);
  const [tabHeight, setTabHeight] = useState(0);
  const [isShow, setIsShow] = useState(false);
  const [hasNextPage, setNextPage] = useState(true);
  const [scrollData, setScrollData] = useState([]);
  const [scroll, setScroll] = useState(false);
  const { width } = useWindowSize();
  const divRef = React.useRef();

  const getMediaData = useCallback(async () => {
    let query = queryString.parse(location.search);
    let ctg = _has(query, 'ctg') ? _toNumber(query.ctg) : 0;
    let page = pageNum + 1;

    mediaStore.setListQuery('mediaList', {
      lang: i18n.language,
      size: 10,
      categoryIdx: ctg,
      page: page,
      hasMore: hasNextPage,
    });

    await mediaStore.getMediaList();

    if (mediaStore.mediaList.totalPages < page) {
      setNextPage(false);
      return;
    }

    setPageNum(page);
    setActiveCtg(ctg);

    if (
      mediaStore.mediaList.totalPages >= page &&
      !_isEmpty(mediaStore.mediaList.contents)
    ) {
      const data = mediaStore.mediaList.contents;
      let arrayData = [];
      data.forEach(item => {
        arrayData.push(item);
      });
      setScrollData(scrollData.concat(arrayData));

      return true;
    }
  }, [mediaStore, scrollData, pageNum, activeCtg, hasNextPage, i18n.language]);

  const getData = useCallback(async () => {
    await mediaStore.getMediaCategory();
    await mediaStore.getMainBanner();
    let query = queryString.parse(location.search);
    let ctg = _has(query, 'ctg') ? _toNumber(query.ctg) : 0;
    if (pageNum == 0) {
      mediaStore.setListQuery('mediaList', {
        lang: i18n.language,
        size: 10,
        categoryIdx: ctg,
        page: 1,
        hasMore: hasNextPage,
      });

      await mediaStore.getMediaList();
      const data = mediaStore.mediaList.contents;

      setScrollData(data);
      setPageNum(1);
      setActiveCtg(ctg);
    }

    return true;
  }, [mediaStore, pageNum, activeCtg, hasNextPage, i18n.language]);

  useEffect(() => {
    getData();
  }, [mediaStore, getData]);

  const onClickTab = (e, ctg) => {
    if (e != null) e.preventDefault();
    let query = queryString.parse(location.search);
    query.ctg = ctg;
    navigate('?' + queryString.stringify(query));

    setActiveCtg(ctg);
    setPageNum(0);
    setNextPage(true);
    getData();
  };

  const allShow = () => {
    setIsShow(true);
  };

  return (
    <div className="md:container mx-auto pl-[30px] pr-[30px]">
      <div className={'mb-10'}>
        {!_isEmpty(mediaStore.banner) && (
          <TopBanner banner={mediaStore.banner} />
        )}
      </div>
      <div ref={divRef} className={'h-1'}></div>
      {!_isEmpty(mediaStore.category) && !_isEmpty(mediaStore.mediaMap) && (
        <div id="mediaTabWrap" className={'mb-[5px]'}>
          <MediaTab
            category={mediaStore.category}
            onClickTab={onClickTab}
            activeCtg={activeCtg}
            isShow={isShow}
            allShow={allShow}
            mediaMap={mediaStore.mediaMap.contents}
          />
        </div>
      )}

      <div>
        {!_isEmpty(mediaStore.mediaList) && !_isEmpty(scrollData) && (
          <InfiniteScroll
            dataLength={scrollData.length} //This is important field to render the next data
            next={getMediaData}
            hasMore={hasNextPage}
          >
            <div className={'grid grid-cols-2 gap-10'}>
              {!_isEmpty(scrollData) &&
                scrollData.map((row, idx) => {
                  return <MediaScrollData data={row} key={idx} />;
                })}
            </div>
          </InfiniteScroll>
        )}
      </div>
    </div>
  );
};

export default observer(MediaList);
